import { hasValidProperty } from "src/app/helpers/obj"

const hasFilterProps = (obj) => {
    const props = [
        'findoc_number',
        'customer_name',
        'sap_number',
        'created_at',
        'sales_org_code',
        'sector_id',
        'tgl_findoc',
        'num_findoc',
        'findoc_type',
        'type_skbdn',
        'no_skpp',
        'negara_desc',
        'currency',
        'bank_name',
        'nilai',
        'allowance',
        'resedual_value',
        'top',
        'incoterm',
        'validity_date_from',
        'validity_date_to',
        'delivery_deadline',
        'status',
    ]

    return hasValidProperty(obj, props)
}

export {
    hasFilterProps
}
